// angular
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AppService } from '../../../app.service';

@Component({
    selector: 'me-payment-error',
    templateUrl: './payment-error.component.html',
    styleUrls: ['./payment-error.component.scss']
})

export class MePaymentErrorComponent implements OnInit {
    url = 'payment/payment-error';
    data = {};

    constructor(
        public appService: AppService,
        public translate: TranslateService,
        public router: Router
    ) {

    }

    ngOnInit() {
        this.getContentPayment();
        this.translate.onLangChange.subscribe(() => {
            this.getContentPayment();
        });
    }

    getContentPayment() {
        this.appService.getStoryBlokDataForClinic(this.url).subscribe(res => {
            this.data = res['story']['content'] ?? [];
        });
    }

    gotoHome() {
        this.router.navigate(['me/dashboard']);
    }
}
